import {connect} from "redux-vue";

const Footer = {
  /**
   *
   */
  props: ['user'],

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const isAuthorized = !!(this.user.token && this.user.model);

    return (
      <fragment>
        <footer class="bg-teal-800">
          <div class="container mx-auto px-6 lg:px-0 flex items-start lg:items-end pt-4 pb-2 lg:py-4">

            <div class="hidden lg:block w-2/5 pr-3 border-facebook border-teal-600 flex-shrink-0">
              <i class="text-6xl text-teal-100 mdi mdi-facebook leading-none block"></i>
              <h3 class="text-base text-teal-100 font-bold mb-2">
                {this.$t('whatsapp_promo.h1')}
              </h3>
              <p class="text-white text-sm mb-3" domPropsInnerHTML={this.$t('whatsapp_promo.p')}></p>
            </div>
            <div class="flex flex-col lg:flex-col-reverse lg:px-12 py-3 text-center lg:text-left">
              <ul
                class="flex justify-center lg:justify-start items-center text-teal-100 flex-wrap text-xs lg:text-sm font-bold lg:font-normal">
                <li>
                  <router-link to={{name: 'CoursesPage'}}>
                    {this.$t(isAuthorized ? 'nav.my_courses' : 'nav.courses')}
                  </router-link>
                </li>
                <li class="text-white px-3">
                  <span class="hidden lg:block">|</span>
                  <span class="lg:hidden">•</span>
                </li>
                <li>
                  <router-link to={{name: 'AboutPage'}}>
                    {this.$t('nav.about_us')}
                  </router-link>
                </li>
                <li class="text-white px-3">
                  <span class="hidden lg:block">|</span>
                  <span class="lg:hidden">•</span>
                </li>
                <li>
                  <a href="//watch.immunizationacademy.com" target="_blank">
                    IA Watch
                  </a>
                </li>
                <li class="text-white px-3 hidden lg:block">
                  <span class="hidden lg:block">|</span>
                  <span class="lg:hidden">•</span>
                </li>
                <li class="mt-3 lg:mt-0 w-full lg:w-auto">
                  <a href="//immunizationacademy.com/" target="_blank">
                    {this.$t('nav.bcl_institute')}
                  </a>
                </li>
              </ul>
              <p class="text-white text-xs lg:text-sm mt-5 lg:mt-0 lg:mb-5">
                {this.$t('footer_copy')}
              </p>
            </div>

          </div>
        </footer>

        <footer class="bg-accent_dark">
          <div class="container mx-auto px-6 lg:px-0 py-0 lg:py-3">
            <div class="w-full flex flex-col-reverse lg:flex-row items-center justify-between">
              <div class="flex items-center flex-col-reverse lg:flex-row">
                <p class="text-white text-xs lg:text-sm py-3 lg:py-0">
                  ©2020 IA Learn
                </p>
                {/* <ul class="lg:ml-16 flex items-center text-xs lg:text-sm text-white">
                  <li>
                    <a href="#">
                      English
                    </a>
                  </li>
                  <li class="px-2">•</li>
                  <li>
                    <a href="#" class="text-yellow-500">
                      Français
                    </a>
                  </li>
                  <li class="px-2">•</li>
                  <li>
                    <a href="#" class="text-yellow-500">
                      Kiswahili
                    </a>
                  </li>
                  <li class="px-2">•</li>
                  <li>
                    <a href="#" class="text-yellow-500">
                      Hausa
                    </a>
                  </li>
                </ul> */}
              </div>
              <ul class="text-white text-xs lg:text-sm flex items-center my-3 lg:my-0">
                <li>
                  <router-link to={{name: 'HelpPage'}}>
                    {this.$t('nav.help')}
                  </router-link>
                </li>
                <li class="px-2 lg:px-3 invisible lg:visible">|</li>
                <li>
                  <a href="https://watch.immunizationacademy.com/privacypolicy" target="_blank">
                    {this.$t('nav.privacy_policy')}
                  </a>
                </li>
                <li class="px-2 lg:px-3 invisible lg:visible">|</li>
                <li>
                  <a href="https://watch.immunizationacademy.com/termsofuse" target="_blank">
                    {this.$t('nav.terms_of_use')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </footer>
      </fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapActionToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapActionToProps)(Footer);
